import { render } from "./FichaSaida.vue?vue&type=template&id=1c3ffa9b&scoped=true"
import script from "./FichaSaida.vue?vue&type=script&lang=js"
export * from "./FichaSaida.vue?vue&type=script&lang=js"

import "./FichaSaida.vue?vue&type=style&index=0&id=1c3ffa9b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c3ffa9b"]])

export default __exports__